// @flow
import { Box, Grid, Paper } from "@material-ui/core";
import { isNil } from "lodash-es";
import React, { useEffect, useState } from "react";
import { ErrorModal } from "../../components/modals/error-modal";
import Trending from "./components/chart/Trending";
import { useTrendingContext } from "./components/chart/context/TrendingContext";
import {
	View,
	ViewTag,
	ViewTagsMap,
} from "./components/chart/models/TrendingModels";
import {
	getViewTags,
	getViews,
} from "./components/chart/repository/TrendingRepository";
import { getRandomColor } from "./components/chart/utils/tagColors";

type Props = {};
export const TrendingsPage = (props: Props) => {
	const [error, setError] = useState("");

	const {
		state: { viewSelected },
		actions: { setViews, setViewTagsAndRefetch, setViewSelected },
	} = useTrendingContext();

	const getTagsFromAPI = async (forceReload = false) => {
		//views
		const viewsResp = await getViews(null);
		if (viewsResp.ok) {
			setViews(viewsResp.data.tables[0].rows);

			let lastCreated: View;
			if (!viewSelected || forceReload) {
				lastCreated = viewsResp.data.tables[0].rows.reduce(
					(prev: View, current: View) =>
						prev && prev.ViewId > current.ViewId ? prev : current,
					null,
				);

				//viewSelected
				setViewSelected(lastCreated);
			} else {
				lastCreated = viewSelected;
			}
			//viewTags
			if (lastCreated) {
				const viewTagsResp = await getViewTags(lastCreated.ViewId);
				if (viewTagsResp.ok) {
					const viewTags = viewTagsResp.data.tables[0].rows.reduce(
						(carr: ViewTagsMap, curr: ViewTag, idx: number) => {
							if (isNil(curr.Color)) {
								curr.Color = getRandomColor();
							}
							carr[curr.TagId] = {
								viewTag: curr,
								order: idx,
							};
							return carr;
						},
						{},
					);
					setViewTagsAndRefetch(viewTags);
				} else {
					setError(viewTagsResp.message);
				}
			}
		} else {
			setError(viewsResp.message);
		}
	};

	useEffect(() => {
		getTagsFromAPI();
	}, []);

	return (
		<>
			<Box p={3} style={{ maxWidth: "100%" }}>
				<Paper>
					<Grid container spacing={3} style={{ padding: "20px" }}>
						<Grid item xs={12}>
							<Trending
								title="Trending Chart"
								getTagsFromAPI={getTagsFromAPI}
							/>
						</Grid>
					</Grid>
				</Paper>
			</Box>
			<ErrorModal
				error={error}
				onHide={() => setError("")}
				size="xl"
				title="ERROR"
			/>
		</>
	);
};
